import { ProductDocument } from "@omni/types/api/product/bff/shared/productDocument.model";
import * as yup from "yup";

import { Translate } from "@/redux/modules/value/translations/translations.provider";
import { string } from "@/utils/validation/schemas/general.RHF";

export type TermsOfServiceCheckDocument = {
    title: string;
    file: ProductDocument;
    checked: boolean;
};

export const RequiredTermsOfServiceSchema = yup.object({
    termsOfServiceChecks: yup
        .array()
        .ensure()
        .of(
            yup.object({
                title: string().required(),
                checked: yup
                    .boolean()
                    .required()
                    .oneOf(
                        [true],
                        () => () => (t: Translate) =>
                            t(
                                "checkout.customerDetails.additionalServiceTermsOfService.validation.required"
                            )
                    ),
                file: yup
                    .object({
                        altText: string().nullable().optional(),
                        code: string().required(),
                        description: string().nullable().optional(),
                        format: string().required(),
                        mimeType: string().nullable().optional(),
                        url: string().url().required()
                    })
                    .required()
            })
        )
        .required()
});

type RequiredTermsOfServiceFieldValues = yup.InferType<
    typeof RequiredTermsOfServiceSchema
>;

export type TermsOfServiceFieldValues = RequiredTermsOfServiceFieldValues;
